import { createProgressStartGuard } from "./NProgressGuard";
export function onChangeRouterStart(router) {
  createProgressStartGuard(router);
  router.beforeEach(async (to, from, next) => {
    if (to.matched.length !== 0) {
      next();
      return true;
    } else {
      next({
        path: "/404"
      });
    }
  });
}